import React from 'react';
import { Checkbox as SemanticCheckbox, CheckboxProps } from 'semantic-ui-react';
import { IFormFieldProps } from './common';
import InputWrap from './InputWrap';
import styles from './styles/Checkbox.module.scss';
import { Check } from 'react-feather';

interface ButtonVariantProps {
  value: any;
  onLabel?: string;
  offLabel?: string;
}

const Checkbox = ({
  basic,
  label,
  description,
  className,
  inputClassName,
  labelClassName,
  leftIcon,
  rightIcon,
  error,
  name,
  tooltip,
  value,
  variant,
  onLabel,
  offLabel,
  onValue,
  offValue,
  onChange,
  ...inputProps
}: IFormFieldProps & CheckboxProps & ButtonVariantProps) => {
  const isButton = variant === 'button';

  const handleChange = (_, data) => {
    const target = {
      name: data.name,
      value: (data.checked ? onValue : offValue) || data.checked,
      checked: data.checked,
    };
    onChange({ target });
  };

  const isChecked = typeof value === 'string' ? value === onValue : value;

  return (
    <InputWrap
      className={classnames(
        styles.inputWrap,
        'checkbox',
        isButton && styles.button,
        className,
      )}
      errorClassName={styles.error}
      error={error}
      label={
        <>
          {isButton && isChecked && (
            <Check className={styles.check} strokeWidth={4} />
          )}
          {label}
        </>
      }
      labelClassName={labelClassName}
      name={name}
      rightIcon={rightIcon}
      description={description}
      tooltip={tooltip}
    >
      <SemanticCheckbox
        id={name}
        name={name}
        checked={isChecked || false}
        {...inputProps}
        label={isButton && (isChecked ? offLabel : onLabel)}
        className={classnames(styles.input, inputClassName)}
        onChange={handleChange}
      />
    </InputWrap>
  );
};

export default Checkbox;
